import { AuthService } from "./../../shared/models/auth.service";
import { Component, OnInit, ViewChild } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { Router, ActivatedRoute } from "@angular/router";
import {
  WeGoConfig,
  IAPIResponse,
  IKeyValueInterface,
  ApplicationRouteURL,
  UserRoles,
  DataListModel
} from "../../shared/config";

import { Location } from "@angular/common";
import { InvoiceService } from "../models/invoice.service";
import {
  PaymentHistoryModel,
  InvoiceBasicDetails
} from "../models/invoice.model";
import { FlatPickrModel } from "../../plugins/flatpickr/flatpickr.model";

@Component({
  selector: "invoice-payment-history",
  template: require('../views/invoice-payment-history.component.html'),
  providers: [InvoiceService]
})
export class InvoicePaymentHistoryListComponent implements OnInit {
  invoiceNumber: string;
  invoiceAmount: string;
  DataListModel: DataListModel;
  paymentHistoryList: PaymentHistoryModel[];
  invoiceBasicDetails: InvoiceBasicDetails = new InvoiceBasicDetails();
  paymentHistoryModel: PaymentHistoryModel;
  apiErrorMsg: string;
  isLoading: boolean;
  apiResponse: IAPIResponse;
  urlDefaultPage: string;
  errorMessage: string;
  errorModel: IKeyValueInterface[];
  urlInvoiceList: string;

  private popupMsg: string;
  private module: string;
  private breadCrumbList: string;
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_FORMAT;
  public dateTimeFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  flatPickrConfigTo: FlatPickrModel;
  flatPickrConfigFrom: FlatPickrModel;

  constructor(
    private invoiceService: InvoiceService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["status", "paymentMode", "description"];
    this.urlInvoiceList = this.authService.GetURL(
      ApplicationRouteURL.URL_BOOKING_INVOICE_LIST
    );
    this.paymentHistoryModel = new PaymentHistoryModel();

    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();

    this.activeRoute.params.subscribe(params => {
      let invoiceHashId = params["invoiceHashId"] || "";
      if (invoiceHashId != "") {
        this.paymentHistoryModel.invoiceHashId = invoiceHashId;
        this.GetInvoicePaymentHistory();
        this.GetBookingInvoiceBasicDetails();
      }
    });
  }

  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = false;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = this.dateTimeFormat;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  public GetInvoicePaymentHistory() {
    this.isLoading = true;
    this.invoiceService
      .GetInvoicePaymentHistory(this.paymentHistoryModel, this.DataListModel)
      .subscribe(
        res => {
          this.paymentHistoryList = res.data;
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.isLoading = false;
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public GetBookingInvoiceBasicDetails() {
    this.invoiceService
      .GetBookingInvoiceBasicDetails(this.paymentHistoryModel.invoiceHashId)
      .subscribe(
        res => {
          this.invoiceNumber = res.data.entityName;
          this.invoiceBasicDetails = res.data.data;
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.invoiceService
      .ExportInvoicePaymentHistory(this.paymentHistoryModel, this.DataListModel)
      .subscribe(
        (res: any) => {
          if (res && res._body) {
            let fileName =
              "InvoicePaymentHistory" + new Date().toISOString() + ".csv";
            this.authService.DownloadFile(fileName, res._body);
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetInvoicePaymentHistory();
  }

  public OnSearch(event: any) {
    if (event.isReset) {
      this.paymentHistoryModel.startDateTime = "";
      this.paymentHistoryModel.endDateTime = "";
    }

    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      event.searchTerm,
      event.isReset
    );
    this.GetInvoicePaymentHistory();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetInvoicePaymentHistory();
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetInvoicePaymentHistory();
  }

  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/invoice/components/invoice-payment-history.component.ts